import { TYPES } from "./default_debug.type";

const initState = {
  defaultDebugAll: null,
  defaultDebugOpenAdd: false,
  defaultDebugOpenEdit: false,
  defaultDebugSelected: null,
  defaultDebugSearch: "",
};

const defaultDebugReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_DEBUG_ALL:
      return {
        ...state,
        defaultDebugAll: payload,
      };

    case TYPES.SET_DEFAULT_DEBUG_OPEN_ADD:
      return {
        ...state,
        defaultDebugOpenAdd: payload,
      };

    case TYPES.SET_DEFAULT_DEBUG_OPEN_EDIT:
      return {
        ...state,
        defaultDebugOpenEdit: payload,
      };

    case TYPES.SET_DEFAULT_DEBUG_SELECTED:
      return {
        ...state,
        defaultDebugSelected: payload,
      };

    case TYPES.SET_DEFAULT_DEBUG_SEARCH:
      return {
        ...state,
        defaultDebugSearch: payload,
      };

    default:
      return state;
  }
};

export default defaultDebugReducer;
